export default "__VITE_ASSET__D3pCc_De__"